/**
 * Active Directory export configuration
 *
 * Shared by ALL AD entity types:
 * - ADUser
 * - ADGroup
 * - ADComputer
 * - ADDomain
 * - ADGPO
 * - ADOU
 * - ADContainer
 * - ADLocalGroup
 * - ADLocalUser
 * - ADAIACA
 * - ADRootCA
 * - ADEnterpriseCA
 * - ADNTAuthStore
 * - ADCertTemplate
 * - ADIssuancePolicy
 */

import type { ExportColumnConfig } from '@/components/export/universal/types';

export const AD_COLUMNS: readonly ExportColumnConfig[] = [
  { id: 'label', label: 'Object Type', defaultSelected: true },
  { id: 'name', label: 'Name', defaultSelected: true },
  { id: 'domain', label: 'Domain', defaultSelected: true },
  { id: 'display_name', label: 'Display Name', defaultSelected: true },
  { id: 'sam_account_name', label: 'SAM Account Name' },
  { id: 'distinguished_name', label: 'Distinguished Name' },
  { id: 'object_id', label: 'Object ID' },
  { id: 'sid', label: 'SID' },
  { id: 'status', label: 'Status', defaultSelected: true },
  { id: 'class', label: 'Class' },
  { id: 'description', label: 'Description' },
  { id: 'admin_count', label: 'Admin Count' },
  { id: 'has_spn', label: 'Has SPN' },
  { id: 'operating_system', label: 'Operating System' },
  { id: 'dns_hostname', label: 'DNS Hostname' },
  { id: 'tags', label: 'Tags' },
  { id: 'first_seen', label: 'First Seen', defaultSelected: true },
  { id: 'last_seen', label: 'Last Seen', defaultSelected: true },
];
